import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Container } from "reactstrap";
import "./docviewer-style.scss";
import NbTreeFile from "../../components/tree/treeFile";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import RestoreIcon from "@mui/icons-material/RestartAlt";
import SaveIcon from "@mui/icons-material/Save";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import { useNavigate, useParams } from "react-router-dom";
import LoadingComponent from "../../components/loading";
import Drawer from "@material-ui/core/Drawer";
import { WrapperDocPlace } from "./components/wrapper/style";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { LiMenu, LiRename, Message, useStyles } from "./style";
import { postDeleteDoc, postDocDownload } from "../../store/explorer/actions";
import { editDocument } from "../../services/docService";
import Typography from "@mui/material/Typography";
import rag from "../../assets/rag.png";
import ViewIcon from "@mui/icons-material/Visibility";
import HistoryIcon from "@mui/icons-material/History";
import DocumentIcon from "../../assets/dockToright.png";
import LookIcon from "../../assets/search.png";

import {
  getDetailFolderList,
  getDocumentPageList,
  getDocumentVersions,
  restoreDocumentVersion,
} from "../../store/document/actions";
import OptionMenuDocPlace from "../FSExplorer/components/files/optionsMenu";
import { confirmAlert } from "react-confirm-alert";
import TextField from "@material-ui/core/TextField";

//DOC-1520
import { getTreeList } from "../../store/tree/actions";
import { ShareDocPlace } from "../FSExplorer/components/files/share";
import { MoveDocPlace } from "../FSExplorer/components/files/move";
import { RenameDocPlace } from "../FSExplorer/components/files/raname";
import { ReprocessDocPlace } from "../FSExplorer/components/files/reprocess";
import InfoIcon from "@mui/icons-material/Info";
import { Alert } from "@mui/material";
import { uploadFileAI } from "../../services/FileUploadService";
//*** end DOC-1520 */
//DOC-2071
import ButtonOptions from "./components/button-options/button-options";
import SignatureDrawerList from "./components/signature-drawer-list/signature-drawer-list";
import DrawIcon from "@mui/icons-material/Draw";
import PermissionChecker from "../../services/permissionsChecker";
import ShareIcon from "@mui/icons-material/Share";
import BorderColorIcon from "@mui/icons-material/BorderColor";

import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import GetAppIcon from "@mui/icons-material/GetApp";
import Swal from "sweetalert2";
// end DOC-2071
import { uploadAndAppendDocument } from "../../services/FileUploadService";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import FileUploadDocPlace from "./components/fileUpload/fileUpload";
import Tooltip from "@mui/material/Tooltip";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

import { SearchIcon, searchPlugin } from "@react-pdf-viewer/search";
import "@react-pdf-viewer/search/lib/styles/index.css";
import { styled } from "@mui/material/styles";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import AgentChat from "../Rag/Agent";
import Dialog from "@mui/material/Dialog";
import DocAssistantButton from "../Rag/DocAssistantButton";
let deleteWord = "";
const plan = JSON.parse(localStorage.getItem("docplace"))?.plan?.id;
var pagesState = [];
const DocViewerDocPlace = (props) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const notify = (msj, event) => toast[event](msj);
  const classes = useStyles();
  const params = useParams();

  const { isSignerRequests } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [startPage, setStartPage] = useState(true);
  const [item, setItem] = React.useState("");
  const [pageSelected, setPageSelected] = React.useState(0);
  const [pageId, setPageId] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const [size, setSize] = React.useState(100);
  const [showOption, setShowOption] = React.useState(false);
  const [showMove, setShowMove] = React.useState(false);
  const [showShare, setShowShare] = React.useState(false);
  const [showRename, setShowRename] = React.useState(false);
  const [showZoom, setShowZoom] = React.useState(false);
  const [permissions, setPermissions] = React.useState(false);
  const [showLoading, setShowLoading] = React.useState(false);
  const [userType, setUserType] = React.useState([]);
  const [updateAllFiles, setUpdateAllFiles] = React.useState(false);
  const [pages, setPages] = React.useState([]);
  const [rotation, setRotation] = useState(0);
  const [totalFiles, setTotalFiles] = React.useState([]);
  const [showVersions, setShowVersions] = useState(false);
  const [versions, setVersions] = React.useState([]);
  const [versionId, setVersionId] = React.useState("");
  const [assistant, setAssistant] = useState(false);
  const [documentIn, setDocumentIn] = React.useState(null);
  const [isVersion, setIsVersion] = React.useState(false);
  const [select, setSelect] = useState(false);
  const updateFile = (files) => {
    setTotalFiles(files);
  };
  const [showRequest, setShowRequest] = useState(false);
  // Usage:
  const [showRestoreModal, setShowRestoreModal] = useState(false);

  let typePlan = [];
  if (JSON.parse(localStorage.getItem("docplace")).plan) {
    typePlan.push(JSON.parse(localStorage.getItem("docplace")).plan);
  }
  const searchPluginInstance = searchPlugin();
  const { highlight, jumpToMatch } = searchPluginInstance;
  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },

    "& .MuiDialog-paper": {
      width: "762px",
      maxWidth: "762px",
    },
  }));
  const { responseDocumentPages, errorDocumentPages, loading } = useSelector(
    (state) => ({
      responseDocumentPages: state.DetailFolder.responseDocumentPages,
      errorDocumentPages: state.DetailFolder.errorDocumentPages,
      loading: state.DetailFolder.loadingDocumentPages,
    })
  );

  /**DOC 1520 */
  const [mapPath, setMapPath] = useState([]);
  const { responseTree, errorTree, loading3 } = useSelector((state) => ({
    responseTree: state.Tree.responseTree,
    errorTree: state.Tree.errorTree,
    loading3: state.Tree.loadingTree,
  }));
  const [tree, setTree] = useState({
    label: "",
    value: "",
    parent: "",
  });
  const { responseDeleteDoc, errorDeleteDoc, loading6 } = useSelector(
    (state) => ({
      responseDeleteDoc: state.Explorer.responseDeleteDoc,
      errorDeleteDoc: state.Explorer.errorDeleteDoc,
      loading6: state.Explorer.loadingDeleteDoc,
    })
  );

  const { responseVersions, errorVersions, loadingVersions } = useSelector(
    (state) => ({
      responseVersions: state.DetailFolder.responseDocumentVersions,
      errorVersions: state.DetailFolder.errorDocumentVersions,
      loadingVersions: state.DetailFolder.loadingDocumentVersions,
    })
  );

  const { responseRestoreVersion, errorRestoreVersion, loadingRestoreVersion } =
    useSelector((state) => ({
      responseRestoreVersion: state.DetailFolder.responseRestoreDocumentVersion,
      errorRestoreVersion: state.DetailFolder.errorRestoreDocumentVersion,
      loadingRestoreVersion: state.DetailFolder.loadingRestoreDocumentVersion,
    }));

  const [pageSize, setPageSize] = useState(200);
  const [inMove, setInMove] = useState(false);
  const [users, setUsers] = useState("");
  const [showReprocess, setShowReprocess] = useState(false);
  const [open, setOpen] = React.useState(false);
  const { responseDocumentPermissions, loadingDocumentPermissions } =
    useSelector((state) => ({
      responseDocumentPermissions:
        state.DetailFolder.responseDocumentPermissions,
      loadingDocumentPermissions: state.DetailFolder.loadingDocumentPermissions,
    }));
  // Doc-2071
  const [openSignatureDrawer, setOpenSignatureDrawer] = React.useState(false);
  // end Doc-2071

  const showInPdf = (text) => {
    highlight([text]);
    jumpToMatch(0);
  };
  //end DOC-1520
  useEffect(() => {
    if (responseDocumentPermissions) {
      setPermissions(responseDocumentPermissions);
    }
  }, [responseDocumentPermissions]);

  useEffect(() => {
    localStorage.setItem("navigation", "/docViewerAssistant");
    /*if (params.id !== "null" && params.id) {
      //    if (!responseDocumentPages) {
      if (startPage === true) {
        dispatch(getDocumentPageList({ id: params.id }, page, size, navigate));
        dispatch(getDocumentVersions(params.id, navigate));
      }
      //  }
    } else {
      setStartPage(false);
      setItem(null);


      pagesState = [];
      setPages([]);
      setSelect(true);

    }*/
  }, []);

  useEffect(() => {
    if (responseDocumentPages && responseDocumentPages.data) {
      setStartPage(false);
      setItem(responseDocumentPages.data);

      pagesState = [];
      setPages([]);

      //Is an older version?
      let data = JSON.parse(localStorage.getItem("docplace-document-version"));

      if (data) {
        setIsVersion(true);
        setDocumentIn(data);
        data.fileReferences.pdfFilePages.map((page, idx) => {
          updatePages(idx, "add", page, data.fileReferences.pages[idx]);
        });
      } else {
        setIsVersion(false);
        setDocumentIn(responseDocumentPages.data);
        data = responseDocumentPages.data;
      }

      data.fileReferences.pdfFilePages.map((page, idx) => {
        updatePages(
          idx,
          "add",
          page,
          responseDocumentPages.data.fileReferences.pages[idx]
        );
      });
    }
  }, [responseDocumentPages]);

  //() => setOpen(false)
  const append = () => {
    setOpen(true);
  };
  const refresh = () => {
    window.location.reload();
    //dispatch(getDocumentPageList({ id: params.id }, page, size, navigate));
  };
  const findPage = (id) => {
    let page = pagesState.find((item) => item.id === id);
    return page;
  };

  const updatePages = (id, action, value, thumb) => {
    if (action == "add") {
      pagesState.push({ id: id, UrlPdf: value, rotate: 0, thumb: thumb });
    }
    if (action == "delete") {
      pagesState = pagesState.filter((item) => item.id !== id);
    }
    if (action == "rotate") {
      let item = pagesState.find((x) => x.id == id);
      if (item) {
        item.rotate = value;
      }
    }
    setPages(pagesState);
  };

  useEffect(() => {
    setUserType(typePlan?.map((user) => user.id));
  }, []);

  const back = () => {
    const plans = ["1", "6", "2", null];
    if (plans.includes(plan) && isSignerRequests !== "true") {
      navigate("/explorer/" + item?.fkArchive?.id);
    } else if (isSignerRequests === "true") {
      navigate("/Esignature-requests");
    } else {
      navigate("/docplaceSign");
    }
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setShowOption(open);
  };

  const openOption = () => {
    setShowOption(true);
  };
  function getMimeType(url) {
    // Extract the file extension from the URL
    const ext = url.split(".").pop();

    // Map file extensions to MIME types
    const mimeTypes = {
      // Image
      bmp: "image/bmp",
      gif: "image/gif",
      jpeg: "image/jpeg",
      jpg: "image/jpeg",
      png: "image/png",
      svg: "image/svg+xml",
      tif: "image/tiff",
      tiff: "image/tiff",
      webp: "image/webp",

      // Document
      doc: "application/msword",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      odp: "application/vnd.oasis.opendocument.presentation",
      ods: "application/vnd.oasis.opendocument.spreadsheet",
      odt: "application/vnd.oasis.opendocument.text",
      pdf: "application/pdf",
      ppt: "application/vnd.ms-powerpoint",
      pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      rtf: "application/rtf",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      zip: "application/zip",
    };

    // Return the corresponding MIME type or an empty string if the extension is not recognized
    return mimeTypes[ext.toLowerCase()] || "";
  }

  const viewFile = async (url) => {
    // Reverse proxy, the best option is to correctly set the CORS rules in AZURE.
    fetch(url, {
      mode: "cors",
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    }) // FETCH BLOB FROM IT
      .then((response) => response.blob())
      .then((blobu) => {
        // RETRIEVE THE BLOB AND CREATE LOCAL URL
        var blob = new Blob([blobu], { type: getMimeType(url) }); //this makes the magic
        var blobURL = URL.createObjectURL(blob);

        var iframe = document.createElement("iframe"); //load content in an iframe to print later

        // Style the iframe to be hidden and full-screen for printing
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0px";
        iframe.style.height = "0px";
        iframe.style.border = "0";
        iframe.style.opacity = "0";
        iframe.style.pointerEvents = "none";

        document.body.appendChild(iframe);

        iframe.src = blobURL;
        iframe.onload = function () {
          // Wait a bit longer to ensure PDF is fully loaded
          setTimeout(function () {
            try {
              // Function to clean up iframe and blob URL
              let cleanedUp = false;
              const cleanup = () => {
                if (cleanedUp) return; // Prevent double cleanup
                cleanedUp = true;
                if (iframe && iframe.parentNode) {
                  document.body.removeChild(iframe);
                }
                URL.revokeObjectURL(blobURL);
                setShowLoading(false);
              };

              // Listen for afterprint event on iframe (fires when print dialog closes)
              const iframeAfterPrintHandler = () => {
                cleanup();
                if (iframe.contentWindow) {
                  iframe.contentWindow.removeEventListener('afterprint', iframeAfterPrintHandler);
                }
              };

              // Also listen on main window as fallback (more reliable in some browsers)
              const windowAfterPrintHandler = () => {
                cleanup();
                window.removeEventListener('afterprint', windowAfterPrintHandler);
              };

              // Add afterprint listeners if supported
              if (iframe.contentWindow) {
                iframe.contentWindow.addEventListener('afterprint', iframeAfterPrintHandler);
              }
              window.addEventListener('afterprint', windowAfterPrintHandler);

              // Focus the iframe and print
              iframe.focus();
              iframe.contentWindow.print();
              
              // Hide loading immediately after print dialog opens (not waiting for cleanup)
              setShowLoading(false);
              
              // Fallback cleanup with very long timeout (only if afterprint doesn't fire)
              // This should rarely trigger, but prevents memory leaks if events fail
              setTimeout(() => {
                if (!cleanedUp && iframe && iframe.parentNode) {
                  cleanup();
                  if (iframe.contentWindow) {
                    iframe.contentWindow.removeEventListener('afterprint', iframeAfterPrintHandler);
                  }
                  window.removeEventListener('afterprint', windowAfterPrintHandler);
                }
              }, 60000); // 60 seconds - should be enough for any print operation
            } catch (err) {
              console.error("Print error:", err);
              if (iframe && iframe.parentNode) {
                document.body.removeChild(iframe);
              }
              URL.revokeObjectURL(blobURL);
              setShowLoading(false);
              toast.error(`There was an error printing the file`);
            }
          }, 500); // Increased timeout to ensure PDF is fully loaded
        };
      })
      .catch((err) => {
        toast.error(`There was an error reading the file ` + err);
        setShowLoading(false);
      });
  };

  const printOption = (page) => {
    setShowLoading(true);
    let fileToPrint = null;
    if (page) {
      // Print specific page
      fileToPrint = page;
    } else {
      // Always print the full document PDF (not the current page)
      // Use the PDF URL which contains all pages
      fileToPrint = item?.fileReferences?.pdf || item?.fileReferences?.file;
      if (!fileToPrint) {
        toast.error(`Unable to find document to print`);
        setShowLoading(false);
        return;
      }
    }
    try {
      viewFile(fileToPrint);
    } catch (error) {
      toast.error(`There was an error printing the file ` + error);
      setShowLoading(false);
    }
  };

  const saveDocumentVersion = () => {
    fetch(item.fileReferences.file)
      .then((response) => {
        response.blob().then((blob) => {
          // Creating new object of PDF file
          const fileURL = window.URL.createObjectURL(blob);
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = item.fileReferences.file;
          alink.click();
        });
      })
      .catch((e) => {
        toast.error(`There was an error saving the document ` + e);
      });
  };

  /*const save = (upload) => {
    setShowLoading(true);
    let bpages = [];

    pages.map((page, idx) => {
      bpages.push({
        UrlPdf: page.UrlPdf,
        Action: "ROTATE",
        Grades: page.rotate,
      });
    });
    let body = {
      documentId: params.id,
      TypeAction: "Edit",
      pages: bpages,
    };

    editDocument(body, (event) => { })
      .then((response) => {
        toast.success("Document has been saved.");
        if (upload === true) {
          saveUpload();
        } else {
          setShowLoading(false);
          refresh();
        }
      })
      .catch((error) => {
        toast.error(
          "There is an error saving the document. Please contact your administrator." +
          error
        );
        setShowLoading(false);
      })
      .finally(() => {
        setShowLoading(false);
      });
  };
*/
  const saveDocumentVersions = () => {
    if (this.props.pages === null) {
      return;
    }

    // save current page before get all document pages !
    try {
      this.saveCurrentCanvasPage();
    } catch (e) {}

    let id = this.state.currentDocumentId;
    const item = new Map(JSON.parse(localStorage.getItem(id)));

    if (item == null) {
      return;
    }

    // retrieve all pages
    let blobArray = null;

    // create blob array (promises)
    try {
      blobArray = this.props.pages.map((pageItem, index) => {
        // json canvas document storage ID
        const docPageKey = id + "_" + index;
        let docPageCanvasData = localStorage.getItem(docPageKey);

        // if pages has a data storage
        if (docPageCanvasData !== null) {
          // get data from json storage
          return this.loadJSONToCanvas(index, docPageCanvasData);
        } else {
          // get data form original page image
          return this.loadURLFromJSONToCanvas(item, index);
        }
      });
    } catch (e) {}

    // send files array to server POST
    if (blobArray == null) {
    } else {
      // send request only if we have all tasks completed
      Promise.all([...blobArray]).then((responseArray) => {
        try {
          this.uploadBlobFiles(responseArray);
        } catch (e) {
          toast.error(`There was an error: Error on upload blob files`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
    }
  };

  /**I still don't fully understand what is supposed to update here, according to the other code it seems to modify a type of files count, I assume that is
   * only applicable to the explorer
   */

  /**After a successfull comment, we need to update all the information of the page */
  const callAddComment = (comment) => {
    refresh();
  };

  /**DOC-1705 download file, replicating explorer methods to docviewer */
  const { responseDocDownload, loadingDocDownload } = useSelector((state) => ({
    responseDocDownload: state.Explorer.responseDocDownload,
    loadingDocDownload: state.Explorer.loadingDocDownload,
  }));

  const setRequest = (request) => {
    setShowRequest(false);
    navigate("/docViewer/" + request[0].id);
    window.location.reload();
  };
  useEffect(() => {
    if (responseDocDownload) {
      const blob = new Blob([responseDocDownload], {
        type: "application/octetstream",
      });
      const link = document.createElement("a");
      // create a blobURI pointing to our Blob
      const lastIndex = item?.fkArchive?.name?.lastIndexOf(".");
      const nameSplit = item?.fkArchive
        ? item?.fkArchive?.name?.slice(0, lastIndex)
        : "";
      link.href = URL.createObjectURL(blob);
      link.download = item.fkArchive
        ? item.fkArchive?.originalExtension
          ? nameSplit + item.fkArchive.originalExtension
          : item.fkArchive?.name
        : "";
      // some browser needs the anchor to be in the doc
      if (link.download) {
        document.body.append(link);
        link.click();
      }
      link.remove();
      // in case the Blob uses a lot of memory
      setTimeout(() => URL.revokeObjectURL(link.href), 7000);
    }
  }, [responseDocDownload]);

  useEffect(() => {}, [loadingDocDownload]);

  /**End of DOC-1705 */

  const optionMenu = (opt) => {
    switch (opt) {
      case "download":
        {
          if (item.fkArchive?.originalExtension) {
            let type = item.fkArchive?.originalExtension
              .toUpperCase()
              .replace(".", "");
            dispatch(
              postDocDownload(
                {
                  archiveId: item.fkArchive.id,
                  fileName: item.fileReferences.originalFileName
                    ? item.fileReferences.originalFileName
                    : item.fkArchive.name,
                  type: type,
                },
                navigate
              )
            );
            setShowOption(false);
          } else {
            notify(
              "Something is wrong, is not possible download the document!",
              "error"
            );
          }

          return null;
        }
        break;
      case "move":
        {
          getInitialTree(item);
          setShowMove(true);
          setShowOption(false);
          setInMove(true);
        }
        break;
      case "rename":
        {
          setShowRename(true);
          setShowOption(false);
          setInMove(true);
        }
        break;
      case "delete":
        {
          deleteItem();
          setShowOption(false);
          setInMove(true);
        }
        break;
      case "share":
        {
          setShowShare(true);
          setShowOption(false);
        }
        break;
      case "reprocess":
        {
          setShowReprocess(true);
          setShowOption(false);
          setInMove(true);
        }
        break;
      case "fileLocation":
        {
          back();
          setShowOption(false);
        }
        break;
      default: {
      }
    }
    return null;
  };

  /**build on the fly the message to delete the file */
  const deleteItem = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="deleteConfirm custom-ui">
            <h1 style={{ margin: "-43px 0px 0px 0px" }}>Are you sure?</h1>
            <p>
              Write the text "DELETE" in the following box and confirm the
              deletion of the item. The item will be moved to the trash bin and
              remain there for 30 days before being permanently deleted
            </p>

            <TextField
              style={{
                width: "100%",
                backgroundColor: "#fff",
                marginBottom: "26px",
              }}
              id="delete"
              variant="filled"
              onChange={(e) => (deleteWord = e.target.value)}
              label="Write DELETE"
            />

            <Button className={classes.btnCancel} autoFocus onClick={onClose}>
              NO
            </Button>

            <Button
              className={classes.btnDelete}
              autoFocus
              onClick={() => {
                if (deleteWord === "DELETE") {
                  callDelete();
                  onClose();
                } else {
                  toast.error("Wrong Key!");
                }
              }}
            >
              Yes, Delete it!
            </Button>
          </div>
        );
      },
    });
  };

  /**
   * DOC 1520
   */

  //Move functions
  /** navigates up in the tree */
  const backTree = (item) => {
    let newMap = [];
    let end = mapPath.length;
    let origin = mapPath[mapPath.length - 1].parent;
    dispatch(
      getTreeList({ parentArchiveId: item.value, direction: "UP" }, navigate)
    );
    if (!item.value) setTree([]);
    mapPath.map((map, idx) => {
      if (map.id != mapPath[end - 1].id) {
        newMap.push(map);
      }
    });
    dispatch(
      getDetailFolderList(
        {
          parentArchiveId:
            newMap.length > 0 ? newMap[newMap.length - 1].id : origin,
          page: 1,
          pageSize: pageSize,
        },
        navigate
      )
    );
    setMapPath(newMap);
    setPage(1);
  };

  /**Opens the move modal*/
  const callMove = (moveFile) => {
    setShowMove(false);
    if (inMove) {
      setTimeout(() => {
        setInMove(false);
        window.history.go(-1);
      }, 4000);
    }
  };

  /**closed action */
  const closeModal = () => {
    setShowMove(false);
    setInMove(false);
    setShowShare(false);
    setShowRename(false);
    setShowReprocess(false);
    setInMove(false);
  };

  /**Get the current map from the url params, because the map is build through the navigation in the explorer,  */
  const getInitialTree = (item) => {
    let map = []; //DOC 1705 always set to root
    setMapPath(map);
    dispatch(
      getTreeList(
        {
          parentArchiveId: map.length > 0 ? map[map.length - 1].id : "",
          direction: "",
        },
        navigate
      )
    );
  };

  /**Action after a successfull share */
  const callShare = (shareFiles) => {
    setShowShare(false);
    notify("The file was successfully shared", "success");
    //props.shareFile({ shareFiles: shareFiles, item: item });
  };

  /**After a successfull remane */
  const callRename = (renameFiles) => {
    setShowRename(false);
    refresh();
  };

  /**Call reprocess image */
  const callReprocess = (reprocessFiles) => {
    setShowReprocess(false);
  };

  /**Call for delete the current file */
  const callDelete = () => {
    let id = [];
    setPage(1);
    id.push(item.folder ? item.id : item.fkArchive.id);
    dispatch(postDeleteDoc(id, navigate));
  };

  /**Hook to return to explorer after the successfull erase of the current document, takes 4 seconds to read the successfull message box */
  useEffect(() => {
    if (responseDeleteDoc && inMove) {
      setTimeout(() => {
        setInMove(false);
        window.history.go(-1);
      }, 4000);
    }
  }, [responseDeleteDoc]);

  const saveUpload = () => {
    setShowLoading(true);
    totalFiles.map((file) => {
      //setUploaded(true);
      //setMessageText("Uploading document");
      uploadAndAppendDocument(file, true, null, null, params.id, (event) => {
        //showLoading8(true);
      })
        .then((response) => {
          notify("File has been uploaded.", "success");
          //setCloseUploadFiles(true);
          setOpen(false);
          setShowLoading(true);
          //function to reload window in 3 seconds
          refresh();
        })
        .catch((err) => {
          setShowLoading(true);
          setOpen(false);
          toast.error(err?.response?.data?.error?.messages[0].message);
        })
        .finally(() => {
          //setShowLoading(false);
        });
    });

    // setUpDocType({});
  };

  useEffect(() => {
    if (responseVersions && responseVersions.data) {
      setVersions(responseVersions.data);
    }
  }, [responseVersions]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    bgcolor: "background.paper",
    p: 4,
  };
  const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "20%",
    bgcolor: "background.paper",
    p: 4,
  };

  const RestoreModal = ({ open, onClose, onConfirm }) => {
    return (
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style2}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you sure you want to restore this version?
          </Typography>
          <Typography
            component={"div"}
            id="modal-modal-description"
            sx={{ mt: 2, float: "right" }}
          >
            <Button
              variant="contained"
              color="success"
              onClick={onConfirm}
              sx={{ ml: 2 }}
            >
              Yes
            </Button>
            <Button
              variant="contained"
              color="error"
              sx={{ ml: 2 }}
              onClick={onClose}
            >
              No
            </Button>
          </Typography>
        </Box>
      </Modal>
    );
  };

  const viewVersion = (version) => {
    localStorage.setItem("docplace-document-version", JSON.stringify(version));
    setShowVersions(false);
    navigate(0);
  };

  const goDefault = () => {
    localStorage.removeItem("docplace-document-version");
    navigate(0);
  };

  const setDefault = (id) => {
    setVersionId(id);
    setShowRestoreModal(true);
  };

  const restoreVersion = () => {
    let body = {
      documentId: params.id,
      versionId: versionId,
    };
    setShowLoading(true);
    dispatch(restoreDocumentVersion(body, navigate));
  };

  useEffect(() => {
    if (responseRestoreVersion) {
      //notify("The older version has been restored and set as default.", "success");
      setShowRestoreModal(false);
      setShowVersions(false);
      localStorage.removeItem("docplace-document-version");
      setTimeout(() => {
        navigate(0);
        setShowLoading(false);
      }, 3000);
    }
  }, [responseRestoreVersion]);

  useEffect(() => {
    if (errorRestoreVersion) {
      setShowLoading(false);
      notify("There was an error restoring the older version.", "error");
      setShowRestoreModal(false);
      //refresh();
    }
  }, [errorRestoreVersion]);
  const toggleAssistant = () => {
    setAssistant(!assistant);
  };
  const setUserId = () => {
    const docplaceData = localStorage.getItem("docplace");
    if (docplaceData) {
      return JSON.parse(docplaceData).userId || "";
    }
    return "";
  };

  const save = (upload) => {
    setShowLoading(true);
    totalFiles.forEach((file) => {
      uploadFileAI(file, true, null, null, false)
        .then((response) => {
          toast.success("File has been uploaded.");
          setTimeout(() => {
            window.location.href = `/docViewer/${response?.data?.documentId}`;
          }, 2000);
          setTotalFiles([]);
        })
        .catch((err) => {
          toast.error("Error uploading file. ");
        })
        .finally(() => {
          setShowLoading(false);
        });
    });

    /*
    const formData = new FormData();
    formData.append("file", totalFiles);
    formData.append("origin", "Web Ui");
    formData.append("originType", "Web Ui");
    formData.append("originId", "Web Ui");
    formData.append("client-id", setCustomerId()); // Corrected: Use appropriate value or state variable
   // formData.append("docTypeId", "");
   // formData.append("ignoreDynamicLocation", true);
  
   console.log("formData", formData,totalFiles);
    const docplaceData = localStorage.getItem("docplace");
    const parsedData = docplaceData && JSON.parse(docplaceData);
  
    if (!parsedData || !parsedData.token) {
      toast.error("Authentication token missing");
      setShowLoading(false);
      return;
    }
  
    fetch(`${process.env.REACT_APP_HOST_API}/docs/Api/V1/Documents/Upload`, {
      method: "POST",
      headers: {
        "Content-Type":
        "multipart/form-data; boundary=<calculated when request is sent>",
        Authorization: `Bearer ${parsedData.token}`,
      },
      body: formData,
    })
      .then((response) => {
        setShowLoading(false);
        if (!response.ok) {
          throw new Error("Failed to upload files");
        }
        return response.json();
      })
      .then((data) => {
        toast.success("Files uploaded successfully");
        if (upload) {
          saveUpload();
        } else {
          refresh();
        }
      })
      .catch((error) => {
        toast.error(`Error uploading files: ${error.message}`);
        setShowLoading(false);
      }); */
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>DocPlace Doc Viewer</title>
        </MetaTags>
        <Container fluid>
          {/* Floating Button */}
          <DocAssistantButton onShowAgent={toggleAssistant} />
          <ToastContainer autoClose={3000} />
          <LoadingComponent show={loading} text={"Getting Document Data..."} />
          <LoadingComponent show={showLoading} text={"Processing..."} />
          <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Upload file
              </Typography>
              <Typography
                component={"div"}
                id="modal-modal-description"
                sx={{ mt: 2 }}
              >
                <Message>
                  Select a document from your computer to upload. You can also
                  drag and drop the file.
                </Message>
              </Typography>

              <FileUploadDocPlace
                uploadF={updateFile.bind(this)}
                updateAllFiles={updateAllFiles}
              ></FileUploadDocPlace>

              <Button
                variant="contained"
                color="success"
                disabled={totalFiles.length === 0}
                onClick={() => {
                  save(true);
                }}
                sx={{ mt: 2 }}
                style={{ float: "right" }}
              >
                Upload
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => setOpen(false)}
                sx={{ mt: 2, mr: 2 }}
                style={{ float: "right" }}
              >
                Cancel
              </Button>
            </Box>
          </Modal>
          <RestoreModal
            open={showRestoreModal}
            onClose={() => setShowRestoreModal(false)}
            onConfirm={() => {
              // Perform restore logic here
              // ...
              restoreVersion();
              setShowRestoreModal(false);
            }}
          />
          <Modal
            open={showVersions}
            onClose={() => setShowVersions(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Older Versions
              </Typography>
              <Typography
                component={"div"}
                id="modal-modal-description"
                sx={{ mt: 2 }}
              >
                <table className="table">
                  <thead>
                    <tr>
                      <th>Version</th>
                      <th>Creation date</th>
                      <th>View</th>
                      <th>Restore</th>
                    </tr>
                  </thead>
                  <tbody>
                    {versions.map(function (element, i) {
                      const formattedDate = new Date(
                        element.createdAt
                      ).toLocaleDateString();
                      return (
                        <tr key={i}>
                          <td>{element.version}</td>
                          <td>{formattedDate}</td>
                          <td>
                            {" "}
                            <Button
                              onClick={() => viewVersion(element)}
                              sx={{ mt: 2 }}
                              title="View this version"
                              style={{ textAlign: "center" }}
                            >
                              <ViewIcon />
                            </Button>
                          </td>
                          <td>
                            <Button
                              onClick={() => setDefault(element.id)}
                              sx={{ mt: 2 }}
                              title="Restore this version"
                              style={{ textAlign: "center" }}
                            >
                              <RestoreIcon />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() => setShowVersions(false)}
                sx={{ mt: 2 }}
                style={{ float: "right" }}
              >
                Close
              </Button>
            </Box>
          </Modal>

          <WrapperDocPlace className="docViewer">
            {isVersion && (
              <Alert
                icon={<InfoIcon fontSize="inherit" />}
                severity="warning"
                style={{}}
              >
                You are viewing an read-only older version ({documentIn.version}
                ) of this file from{" "}
                {new Date(documentIn.createdAt).toLocaleDateString()}. Click on
                the{" "}
                <span onClick={goDefault} className="restore">
                  here
                </span>{" "}
                to open the latest version or{" "}
                <span
                  onClick={() => setDefault(documentIn.id)}
                  className="restore"
                >
                  here
                </span>{" "}
                to set this version as the latest version.
              </Alert>
            )}

            {true && (
              <article className="content">
                <section className="left">
                  <div className="title">
                    <h1>Doc Viewer</h1>
                  </div>
                  {assistant && (
                    <div className="div">
                      <AgentChat id={params.id} searchPhrase={showInPdf} />
                    </div>
                  )}
                </section>

                <section className="right">
                  <div>
                    {/*
                      <nav>
                      <ul style={{ position: "relative" }}>
                        <li className="backBtn">
                          <Button
                            style={{ padding: "9px 8px" }}
                            className="btnSearchSimple2"
                            color="primary"
                            onClick={back}
                            startIcon={<ArrowBackIosNewIcon />}
                          >
                            Back
                          </Button>
                        </li>
                        {isVersion === false && (
                          <>
                            <PermissionChecker page={"explorer"}>
                              <li
                                style={{
                                  display: "flex",
                                  position: "relative",
                                  margin: "8px 15px 0 0",
                                  float: "right",
                                  gap: "5px",
                                }}
                              >
                                <Tooltip title={"Save"}>
                                  <button
                                    type="button"
                                    className="btn-doc-new btn-doc-primary"
                                    onClick={save.bind(this)}
                                    disabled={true}
                                  >
                                    <SaveIcon />
                                  </button>
                                </Tooltip>

                                <Tooltip title={"Open File Location"}>
                                  <button
                                    type="button"
                                    className="btn-doc-new btn-doc-primary"
                                    onClick={back}
                                    disabled={true}
                                  >
                                    <DriveFolderUploadIcon />
                                  </button>
                                </Tooltip>
                                <Tooltip title={"Refresh"}>
                                  <button
                                    type="button"
                                    className="btn-doc-new btn-doc-primary"
                                    onClick={refresh.bind(this)}
                                    disabled={true}
                                  >
                                    <RestartAltIcon />
                                  </button>
                                </Tooltip>

                                <Tooltip title={"Document versions"}>
                                  <button
                                    color="secondary"
                                    className="btn-doc-new btn-doc-primary"
                                    onClick={() => setShowVersions(true)}
                                    disabled={versions.length === 0}
                                  >
                                    <HistoryIcon />
                                  </button>
                                </Tooltip>

                              </li>
                            </PermissionChecker>
                            <PermissionChecker page={"eSignatureInbox"}>
                              <LiRename>
                                <Button
                                  color="primary"
                                  onClick={() => {
                                    optionMenu("rename");
                                  }}
                                  startIcon={<BorderColorIcon />}
                                  sx={{ textTransform: "none" }}
                                >
                                  Rename
                                </Button>
                              </LiRename>
                              <LiMenu>
                                <Button
                                  color="primary"
                                  onClick={() => {
                                    optionMenu("share");
                                  }}
                                  startIcon={<ShareIcon />}
                                  sx={{ textTransform: "none" }}
                                >
                                  Share
                                </Button>
                              </LiMenu>
                              <LiMenu>
                                <Button
                                  color="primary"
                                  onClick={() => {
                                    optionMenu("download");
                                  }}
                                  startIcon={<GetAppIcon />}
                                  sx={{ textTransform: "none" }}
                                >
                                  Download
                                </Button>
                              </LiMenu>
                              <LiMenu>
                                <Button
                                  color="error"
                                  onClick={() => {
                                    optionMenu("delete");
                                  }}
                                  startIcon={<DeleteForeverIcon />}
                                  sx={{ textTransform: "none" }}
                                >
                                  Delete
                                </Button>
                              </LiMenu>
                              <li
                                style={{
                                  float: "right",
                                  marginRight: "15px",
                                }}
                              >
                                <div
                                  className="eSignatureAlone"
                                  onClick={() => setOpenSignatureDrawer(true)}
                                >
                                  <DrawIcon
                                    style={{
                                      fontSize: "18px",
                                      margin: "3px 6px 0 6px",
                                    }}
                                  />
                                  <div className="eSignatureText">eSignature</div>
                                </div>
                              </li>
                            </PermissionChecker>

                            <li>
                              <Button
                                className="save"
                                style={{
                                  display: "none",
                                }}
                                onClick={save.bind(this)}
                                startIcon={<SaveIcon />}
                              ></Button>
                            </li>
                          </>
                        )}
                      </ul>


                    </nav>
                      */}
                  </div>

                  <Drawer
                    anchor={"right"}
                    open={openSignatureDrawer}
                    onClose={() => setOpenSignatureDrawer(false)}
                  >
                    <SignatureDrawerList
                      data={item ? item.id : params.id}
                      closeSignature={() => setOpenSignatureDrawer(false)}
                    />
                  </Drawer>
                </section>
                <section
                  className="right"
                  style={{ width: assistant ? "75%" : "100%" }}
                >
                  <div className="div">
                    <div className="search">
                      <BootstrapDialog
                        onClose={() => {
                          setShowRequest(false);
                        }}
                        aria-labelledby="customized-dialog-title"
                        open={showRequest}
                      >
                        <NbTreeFile
                          onClickClose={() => setShowRequest(false)}
                          onClickRequest={setRequest}
                        />
                      </BootstrapDialog>
                      <img src={LookIcon} alt="search" />
                      <div className="search-text">No Document Selected</div>
                      <div className="search-buttons">
                        <Button
                          className="btnSearchSimple"
                          color="primary"
                          variant="contained"
                          onClick={() => setOpen(true)}
                          style={{
                            backgroundColor: "#0076FF",
                          }}
                        >
                          Upload File
                        </Button>
                        <Button
                          variant="contained"
                          className="btnSearchSimple2"
                          color="primary"
                          onClick={() => setShowRequest(true)}
                          style={{
                            backgroundColor: "#0076FF",
                          }}
                        >
                          Select File
                        </Button>
                      </div>
                    </div>
                  </div>
                </section>
              </article>
            )}
          </WrapperDocPlace>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DocViewerDocPlace;
